import { LiveMainState } from 'features/live/interface/live';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { APP_URL } from 'shared/constants/common';
import { State } from 'shared/interface';
import { CategoryDataInterface } from '../../interface';
import { DisciplineSkeleton } from '../loader/sideBarSkeleton/disciplineSkeleton';
import NavigationGroup from './navigationGroup';
import NavigationGroupLive from './navigationLive/navigationGroupLive';

interface NavigationProps {
	className?: string;
	title?: string;
}

const Navigation = ({ title = '', className = '' }: NavigationProps) => {
	const location = useLocation();
	const fetchAllLiveDetails = useSelector<State, LiveMainState[]>((state) => state.live.allLiveEvents);
	const categories = useSelector<State, Record<number, CategoryDataInterface>>((state) => state.categories.all);
	const menu: any = useMemo(() => {
		const orderedCategories = sortBy(categories, ['sortOrder']);
		const levels = groupBy(orderedCategories, (item: CategoryDataInterface) => item.level);

		return Object.entries(levels).map((lvl: [string, CategoryDataInterface[]]) => {
			return groupBy(lvl[1], (item: CategoryDataInterface) => item.parentCategory);
		});
	}, [categories]);

	return menu.length > 0 ? (
		<nav className={`navigation navigation_main ${className} ${location.pathname.includes(APP_URL.live) && 'navigation_live'}`}>
			{title && <strong className="navigation__title">{location.pathname.includes(APP_URL.live) ? 'Live' : `${title}`}</strong>}
			<div className="navigation__content">
				{location.pathname.includes(APP_URL.live) ? (
					<NavigationGroupLive liveMenu={fetchAllLiveDetails} />
				) : (
					<NavigationGroup level={0} menu={menu} categoryId={0} />
				)}
			</div>
		</nav>
	) : (
		<DisciplineSkeleton />
	);
};

export default Navigation;
